/**
 * 请求封装
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-09-17 15:41:23
 */
import axios from 'axios';
import { baseURL } from '@/config/index';
import store from '@/store';
import { message } from 'ant-design-vue';
import { ObjectFilterEmpty, ObjectMap } from './func';
const instance = axios.create({
    baseURL,
    timeout: 60000,
    validateStatus: status => status < 500,
});
const ErrorMsgs = {
    'Network Error': '网络错误，请稍后再试',
};
// 请求拦截
instance.interceptors.request.use(config => {
    const token = store.getters.getToken;
    config.headers = ObjectFilterEmpty({
        Authorization: token ? 'jwt ' + token : undefined,
    });
    const url = config.url ?? '';
    const urlParams = /(\/:\w+)/gm.exec(url);
    let realURL = `${url}`;
    try {
        if (urlParams !== null) {
            const params = Array.from(new Set([...urlParams]));
            const data = {
                ...config.params,
                ...config.data,
            };
            params
                .map((param) => {
                const key = (/\w+/.exec(param) ?? [''])[0];
                return {
                    urlParam: param,
                    key,
                };
            })
                .forEach((param) => {
                if (param.key in data) {
                    realURL = realURL.replace(param.urlParam, `/${data[param.key]}`);
                }
                else {
                    throw new Error(`Request to ${url} has param "${param.key}" but value not found`);
                }
            });
            config.url = realURL;
        }
    }
    catch (err) {
        console.error(err);
    }
    return config;
}, error => {
    message.error(`发送请求出错 msg:${error.message}`);
    return Promise.resolve(error);
});
// 响应拦截器
instance.interceptors.response.use((response) => {
    if (!response.data.success) {
        if (response.data.message) {
            message.error(response.data.message);
        }
        if (response.data.error_code === 3001) {
            store.commit('logout');
            location.href = '/login';
        }
    }
    return Promise.resolve({ ...response, err: null, res: response.data });
}, error => {
    message.destroy();
    if (navigator.onLine === false) {
        message.error('当前网络不可用，请稍候再试');
        return Promise.resolve({
            err: error,
            data: {
                code: 10000,
                msg: 'offline',
            },
        });
    }
    message.error(ErrorMsgs?.[error.message] ?? '服务器开小差了~');
    return Promise.resolve({
        err: error,
        res: null,
        data: {
            code: 10001,
            msg: 'network error',
        },
    });
});
// 参数序列化
const serialization = (params) => {
    return params === undefined
        ? params
        : ObjectMap(params, ([key, val]) => {
            if (Array.isArray(val) &&
                val.length > 0 &&
                (typeof val[0] === 'string' || typeof val[0] === 'number')) {
                return [key, val.join(',')];
            }
            else if (typeof val === 'object') {
                return [key, JSON.stringify(val)];
            }
            else {
                return [key, val];
            }
        });
};
// * 参数序列化，基础版本
export const base_serialization = (params) => {
    return params === undefined
        ? params
        : ObjectMap(params, ([key, val]) => {
            if (typeof val === 'object') {
                return [key, JSON.stringify(val)];
            }
            else {
                return [key, val];
            }
        });
};
/**
 * Get 请求
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-06-10 15:32:24
 */
export const Get = (url, options) => instance.get(url, options);
/**
 * Post 请求
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-06-10 15:33:20
 */
export const Post = (url, data, options) => instance.post(url, serialization(data), options);
/**
 * Patch 请求
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-06-10 15:33:22
 */
export const Patch = (url, data, options) => instance.patch(url, serialization(data), options);
/**
 * Put 请求
 * @author 棠棣
 * @since  2020-06-17 16:13:45
 */
export const Put = (url, data, options) => instance.put(url, serialization(data), options);
/**
 * Delete 请求
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-06-10 15:33:23
 */
export const Delete = (url, options) => instance.delete(url, options);
export default instance;
//# sourceMappingURL=request.js.map